var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "raft-user-lookup-wrapper"
    }
  }, [_c('raft-autocomplete', {
    key: _vm.fieldConfig.field_name,
    ref: "autocomplete",
    attrs: {
      "field-class": "entity-reference-field",
      "id": _vm.fieldConfig.field_name,
      "name": _vm.fieldConfig.field_name,
      "value": _vm.selectedUser,
      "label": _vm.fieldConfig.label,
      "element-id": "raft-user-autocomplete",
      "placeholder": _vm.getPlaceholder(),
      "source": _vm.debounceUserLookup,
      "results-display": _vm.formattedResultsDisplay,
      "results-property": "value",
      "input-class": "form-control",
      "disabled": _vm.disabled,
      "show-label": _vm.showLabel,
      "allow-delete": _vm.allowDelete
    },
    on: {
      "selected": _vm.updateSelected
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function () {
        return [_vm.allowDelete ? _c('a', {
          staticClass: "remove-icon-wrapper",
          on: {
            "click": function ($event) {
              return _vm.$emit('removeField', _vm.value !== null ? _vm.value.id : null, _vm.fieldIndex);
            }
          }
        }, [_c('span', {
          staticClass: "visuallyhidden"
        }, [_vm._v("Remove")]), _vm._v(" "), _c('img', {
          staticClass: "remove-icon",
          attrs: {
            "alt": "Remove",
            "src": _vm.removeSrc
          }
        })]) : _vm._e()];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }